/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Institute slug
 * @export
 * @interface InstituteSlug
 */
export interface InstituteSlug {
    /**
     * 
     * @type {string}
     * @memberof InstituteSlug
     */
    value?: string;
}

/**
 * Check if a given object implements the InstituteSlug interface.
 */
export function instanceOfInstituteSlug(value: object): value is InstituteSlug {
    return true;
}

export function InstituteSlugFromJSON(json: any): InstituteSlug {
    return InstituteSlugFromJSONTyped(json, false);
}

export function InstituteSlugFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstituteSlug {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function InstituteSlugToJSON(json: any): InstituteSlug {
    return InstituteSlugToJSONTyped(json, false);
}

export function InstituteSlugToJSONTyped(value?: InstituteSlug | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
    };
}

